var Backbone, SupportAPIHelper, SupportHoldTimeModel, SupportUtilsHelper,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportAPIHelper = require('../helpers/API');

SupportUtilsHelper = require('../helpers/utils');

Backbone = require('backbone');

SupportHoldTimeModel = (function(superClass) {
  extend(SupportHoldTimeModel, superClass);

  function SupportHoldTimeModel() {
    return SupportHoldTimeModel.__super__.constructor.apply(this, arguments);
  }

  SupportHoldTimeModel.prototype.initialize = function() {
    return this.holdTimeLocaleMap = {};
  };

  SupportHoldTimeModel.prototype.getWaitTimeInformation = function(locale, displayHoldTime) {
    var callBackHandler, url, waitTime;
    if (this.isWaitTimeSet(locale)) {
      waitTime = this.getWaitTimeForLocale(locale);
      return displayHoldTime(waitTime);
    } else {
      url = this.getHoldTimeUrlToFetchCallMeBackFlag(locale);
      callBackHandler = (function(_this) {
        return function(response) {
          if ((response != null ? response.estWaitTime : void 0) != null) {
            return _this.holdTimeSuccess(response, displayHoldTime);
          } else {
            return _this.holdTimeError(displayHoldTime);
          }
        };
      })(this);
      return SupportAPIHelper.get(url, null, callBackHandler, callBackHandler, false);
    }
  };

  SupportHoldTimeModel.prototype.getHoldTimeUrlToFetchCallMeBackFlag = function(locale) {
    var deal_type, ref, url;
    if (locale == null) {
      locale = window.I18n.locale;
    }
    deal_type = (ref = Groupon.Support.currentOrder) != null ? ref.DEAL_TYPE : void 0;
    if (locale != null) {
      url = window.SUPPORTBASEURL + "/hold_time/fetch?deal_type=" + deal_type + "&country_code=" + window.I18n.country + "&callback_locale=" + locale;
    } else {
      url = window.SUPPORTBASEURL + "/hold_time/fetch?deal_type=" + deal_type + "&country_code=" + window.I18n.country;
    }
    return SupportUtilsHelper.addMetaDataQueryParams(url);
  };

  SupportHoldTimeModel.prototype.holdTimeSuccess = function(response, displayHoldTime) {
    this.setWaitTimeForLocale(response.locale, response.estWaitTime);
    return displayHoldTime(response.estWaitTime);
  };

  SupportHoldTimeModel.prototype.holdTimeError = function(displayHoldTime) {
    var waitTime;
    waitTime = this.getDefaultHoldTime();
    return displayHoldTime(waitTime);
  };

  SupportHoldTimeModel.prototype.setWaitTimeForLocale = function(locale, waitTime) {
    return this.holdTimeLocaleMap[locale] = waitTime;
  };

  SupportHoldTimeModel.prototype.isWaitTimeSet = function(locale) {
    return !(this.holdTimeLocaleMap[locale] == null);
  };

  SupportHoldTimeModel.prototype.getWaitTimeForLocale = function(locale) {
    if (this.holdTimeLocaleMap[locale] != null) {
      return this.holdTimeLocaleMap[locale];
    } else {
      return this.getDefaultHoldTime();
    }
  };

  SupportHoldTimeModel.prototype.getDefaultHoldTime = function() {
    return I18n.translate('js.modules.support.one_hour');
  };

  return SupportHoldTimeModel;

})(Backbone.Model);

module.exports = SupportHoldTimeModel;

//# sourceMappingURL=data:application/json;base64,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
